<template>
  <div style="position: relative">
    <v-container fluid class="grey lighten-4" pa-0>
      <v-row no-gutters style="container-data-filter-buttons">
        <v-col class="align-self-center" md="auto" xs="auto" sm="auto">
          <!-- Back button -->
          <crud-button
            x-large
            color="blue-grey darken-1"
            @clicked="back()"
            icon="fa-chevron-left"
            :tooltip="$t('global.crud.buttons.return')"
          />
        </v-col>
        <v-col
          cols="1"
          class="flex-grow-1 flex-shrink-0 container-data-filter-info"
        >
          <v-container fluid pa-0>
            <v-row>
              <v-col sm="12" cols="12">
                <div class="form-field-name">
                  {{ $t("functionalities.profile") }}
                </div>
                <div class="form-field-value">
                  {{ dataFilter.profileCode }}&nbsp;-&nbsp;{{
                    dataFilter.profileDescription
                  }}
                </div>
              </v-col>
            </v-row>
          </v-container></v-col
        >
      </v-row>
    </v-container>
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
            <crud-button
              v-if="$checkPermission('PROFILES')"
              x-large
              color="light-blue lighten-2"
              @clicked="create()"
              icon="fa-plus"
              :tooltip="$t('global.crud.button.add')"
            />
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <!-- Search in table -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="6" cols="12">
                  <v-text-field
                    v-model="filter.allFields"
                    :label="$t('global.datatable.search')"
                    append-icon="fas fa-search"
                    single-line
                  ></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                  <v-select
                    v-model="filter.permission"
                    :items="permissionValues"
                    :label="$t('functionalities.permission')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>

            <!-- clear filters -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="refreshItemsView()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
            <ExportExcel url="/profilesPermissions" :filter="this.filter" />
            <ImportExcel
              url="/profilesPermissions"
              @done="search"
              v-if="$checkPermission('PROFILES')"
            />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.profileCode + item.functionalityCode"
              >
                <td>
                  <!-- Edit record -->
                  <crud-button
                    v-if="$checkPermission('PROFILES')"
                    x-small
                    color="orange"
                    icon="fa-pen"
                    :tooltip="$t('global.crud.buttons.edit')"
                    @clicked="edit(item.profileCode, item.functionalityCode)"
                  ></crud-button>

                  <!-- Delete record -->
                  <crud-button
                    v-if="
                      (item.deletionDate === undefined ||
                        item.deletionDate === null) &&
                        $checkPermission('PROFILES')
                    "
                    x-small
                    color="red"
                    icon="fa-trash"
                    :tooltip="$t('global.crud.buttons.delete')"
                    @clicked="suspend(item.profileCode, item.functionalityCode)"
                  ></crud-button>

                  <!-- Active record -->
                  <crud-button
                    v-else-if="$checkPermission('PROFILES')"
                    x-small
                    color="green"
                    icon="fa-redo"
                    :tooltip="$t('global.crud.buttons.restore')"
                    @clicked="restore(item.profileCode, item.functionalityCode)"
                  ></crud-button>
                </td>
                <td>{{ item.functionality.tag }}</td>
                <td>{{ item.permission }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
      <validation-observer ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card>
          <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="details-list">
            <v-form>
              <v-container>
                <!-- Functionalities -->
                <v-layout row wrap>
                  <v-flex class="sm12">
                    <validation-provider
                      :name="$t('functionalities.code')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        v-model="item.functionalityCode"
                        :disabled="editMode"
                        :items="functionalitiesItems"
                        :loading="functionalities.isLoading"
                        :search-input.sync="functionalities.search"
                        hide-no-data
                        :no-data-text="$t('global.autocomplete.noDataFound')"
                        item-text="tag"
                        item-value="code"
                        :label="$t('functionalities.code')"
                        :placeholder="
                          $t('global.autocomplete.starTypingToSearch')
                        "
                        :error-messages="errors"
                        @focus="functionalities.isEdit = true"
                        @change="functionalities.isEdit = false"
                        clearable
                      ></v-autocomplete>
                    </validation-provider>
                  </v-flex>
                </v-layout>
                <!-- Permission -->
                <v-layout row wrap>
                  <v-flex class="sm12">
                    {{ $t("functionalities.permission") }}
                  </v-flex>
                  <v-switch
                    v-model="item.permission"
                    class="ml-2"
                    :label="$t('functionalities.write')"
                  >
                  </v-switch>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click.native="close()">
              {{ $t("global.buttons.close") }}
            </v-btn>
            <v-btn v-if="editMode" color="orange" text @click="passes(update)">
              {{ $t("global.buttons.update") }}
            </v-btn>
            <v-btn v-else color="green" text @click="passes(save)">
              {{ $t("global.buttons.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<style scoped>
.details-list {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";
import ExportExcel from "@/components/ExportExcel.vue";
import ImportExcel from "@/components/ImportExcel.vue";

const CONTEXT = "/profilesPermissions";
const CONTEXT_PROFILES = "/profiles";
const CONTEXT_FUNCTIONALITIES = "/functionalities";
const ENTITY_NAME = "profilesPermissions.";

export default {
  components: {
    CrudButton,
    ExportExcel,
    ImportExcel
  },
  name: "Perfil",
  props: {
    profile: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: false,
    searchTable: "",
    dataFilter: {
      profileCode: "",
      profileDescription: ""
    },
    filter: {
      profileCode: "",
      allFields: "",
      deletedItems: "ALL",
      permission: ""
    },
    searchTableWaiting: false,
    editMode: false,
    dialog: false,
    item: {},
    items: [],
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    functionalities: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    },
    functionalitiesFilter: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    }
  }),
  computed: {
    deletedItemsValues: function() {
      return [
        { text: this.$t("global.status.all"), value: "ALL" },
        { text: this.$t("global.status.active"), value: "ACTIVE" },
        { text: this.$t("global.status.deleted"), value: "DELETED" }
      ];
    },
    permissionValues: function() {
      return [
        { text: this.$t("global.all"), value: "" },
        { text: this.$t("functionalities.read"), value: "R" },
        { text: this.$t("functionalities.write"), value: "W" }
      ];
    },
    formTitle() {
      return this.editMode
        ? this.$t("profilesPermissions.title.edit")
        : this.$t("profilesPermissions.title.new");
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("functionalities.datatable.profile"),
          value: ENTITY_NAME + "functionalityCode"
        },
        {
          text: this.$t("functionalities.datatable.permission"),
          value: ENTITY_NAME + "permission"
        }
      ];
    },
    functionalitiesItems() {
      return this.functionalities.entries.map(entry => {
        const description = entry.code + " - " + entry.tag;
        return Object.assign({}, entry, { description });
      });
    },
    functionalitiesFilterItems() {
      return this.functionalitiesFilter.entries.map(entry => {
        const description = entry.code + " - " + entry.tag;
        return Object.assign({}, entry, { description });
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.allFields": function() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    },
    "functionalities.search": function(value) {
      console.debug("functionalities.search");
      this.preLoadGenericSearchEntity(
        value,
        this.functionalities,
        CONTEXT_FUNCTIONALITIES
      );
    },
    "functionalitiesFilter.search": function(value) {
      console.debug("functionalitiesFilter.search");
      this.preLoadGenericSearchEntity(
        value,
        this.functionalitiesFilter,
        CONTEXT_FUNCTIONALITIES
      );
    },
    searchTable() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      localhttp
        .post(CONTEXT + "/allPagination/" + this.profile, this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    preLoadGenericSearchEntity(value, object, context, aditionalFilter) {
      if (!object.isLoadingWaiting) {
        setTimeout(() => {
          this.genericSearchEntity(object, context, aditionalFilter);
          object.isLoadingWaiting = false;
        }, 500);
      }
      object.value = value;
      object.isLoadingWaiting = true;
    },
    async genericSearchEntity(object, context, aditionalFilter) {
      console.debug("genericSearchEntity");
      if (!object.isEdit || object.value === null || object.value === "")
        return;

      if (object.isLoading) return;

      object.isLoading = true;

      let filterGeneric = {
        allFields: object.value
      };
      if (aditionalFilter !== undefined) {
        Object.keys(aditionalFilter).forEach(
          key => (filterGeneric[key] = aditionalFilter[key])
        );
      }

      // Lazily load input items
      localhttp
        .post(context + "/allFilter", filterGeneric)
        .then(response => {
          console.debug(response.data);
          object.entries = response.data;
        })
        .catch(e => {
          console.log(e);
          this.$showError();
        })
        .finally(() => (object.isLoading = false));
    },
    create() {
      console.debug("Create element");
      this.editMode = false;
      this.resetDialog();
      this.dialog = true;
    },
    async save() {
      console.debug("Save form");

      this.item.profileCode = this.profile;
      this.item.permission = this.item.permission ? "W" : "R";

      localhttp
        .post(CONTEXT + "/create", this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    edit(profileCode, functionalityCode) {
      console.debug("Edit element " + profileCode + functionalityCode);
      this.editMode = true;
      this.resetDialog();
      localhttp
        .get(CONTEXT + "/" + profileCode + "/" + functionalityCode)
        .then(response => {
          this.item = response.data;
          this.editPrepare(this.item);
          this.item.permission = this.item.permission === "W" ? true : false;
          this.dialog = true;
        })
        .catch(e => {
          console.log(e);
        });
    },
    editPrepare(item) {
      setTimeout(() => {
        this.functionalities.search = item.functionality.tag;
      }, 500);
    },
    async update() {
      console.debug("Update form");
      this.item.permission = this.item.permission ? "W" : "R";
      localhttp
        .put(
          CONTEXT +
            "/update/" +
            this.item.profileCode +
            "/" +
            this.item.functionalityCode,
          this.item
        )
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
          this.item.permission = this.item.permission ? "W" : "R";
        })
        .catch(e => {
          console.log(e);
        });
    },
    async suspend(profileCode, functionalityCode) {
      console.debug("Suspend element " + profileCode + "/" + functionalityCode);
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("global.action.suspend.confirm"),
          { color: "blue" }
        )
      ) {
        localhttp
          .put(CONTEXT + "/delete/" + profileCode + "/" + functionalityCode)
          .then(response => {
            console.log(response.data);
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$showErrorCode(e.response.status);
          });
      }
    },
    restore(id) {
      console.debug("Restore element " + id);
      localhttp
        .put(CONTEXT + "/activate/" + id)
        .then(response => {
          console.log(response.data);
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    refreshItemsView() {
      console.debug("Refresh table");
      this.search();
    },
    close() {
      this.dialog = false;
    },
    resetDialog() {
      this.item = {};
      this.resetFunctionalitiesSearch();
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    resetFunctionalitiesSearch() {
      console.debug("resetFunctionalitiesSearch");
      this.functionalities.search = "";
      this.functionalities.entries = [];
    },
    back() {
      this.$router.push({
        name: "profiles"
      });
    },
    allowedStepTime: m => m % 5 === 0
  },
  beforeMount() {
    this.profile = this.$props.profile;
    localhttp
      .get(CONTEXT_PROFILES + "/" + this.$props.profile)
      .then(response => {
        this.dataFilter.profileCode = response.data.code;
        this.dataFilter.profileDescription = response.data.description;
        if (this.dataFilter.profileCode === null) {
          this.$showErrorMessage(this.$t("global.profile.empty"));
        }
      })
      .catch(e => {
        console.log(e);
        this.$showError();
      });
  }
};
</script>
